import { render } from "./ReseauFooter.vue?vue&type=template&id=2e01ec1d&scoped=true"
import script from "./ReseauFooter.vue?vue&type=script&lang=js"
export * from "./ReseauFooter.vue?vue&type=script&lang=js"

import "./ReseauFooter.vue?vue&type=style&index=0&id=2e01ec1d&scoped=true&lang=css"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142257-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e01ec1d"]])

export default __exports__